// submitPushNotificationToken.js
'use strict';
import fetch from '../resource/customFetch.js';
import getMeData from '../selector/getMeData.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Submit push notification token
 * @kind action
 * @return {Promise} Action promise.
 */
const submitPushNotificationToken =
  ({ fcmToken, pushyToken }) =>
  async (dispatch, getState) => {
    const state = getState();
    const token = getMeData(state, 'token');
    if (!token || (!fcmToken && !pushyToken)) return;

    const selectPath = ['pushNotificationToken'];
    const clientId = getMeData(state, 'clientId');

    const body = {};

    if (fcmToken) body.fcm = fcmToken;
    if (pushyToken) body.pushy = pushyToken;

    const fetchOptions = {
      method: 'PUT',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    };

    const fetchUrl = getResourceUrl({ endpoint: `/devices/${clientId}` });

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);

      if (!response.ok) {
        await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default submitPushNotificationToken;
